export const TMDB_API_KEY = "9fd3ab94d965f38b3b67d6dfde8651fe";

export const TMDB_BASE_URL = "https://api.themoviedb.org/3";

export const TMDB_IMG_BASE = "https://image.tmdb.org/t/p/w500";

export const SHOWCASE_CUTOFF_DATE = "2025-09-09"; // Oldest date shown in showcase

// Movie titles so short they bypass the suggestion cache and go straight to TMDB
export const MOVIE_ALLOWLIST = ["f1", "it", "up", "if", "us", "on", "go", "ma"];

// Genre IDs filtered out of movie suggestions (TMDB genre codes)
export const EXCLUDED_GENRE_IDS = new Set([99, 10767]); // 99 = Documentary, 10767 = Talk Show

// Keywords that flag a movie suggestion as non-fiction / live event
export const EXCLUDED_KEYWORDS = [
  "stand-up", "comedy special", "olympics", "super bowl", "live from",
  "halftime", "concert", "documentary", "special event", "bbc radio 1's", "katy perry",
];

// Congrats-screen GIFs used on days without a custom gif_url. Deliberately not
// movie scenes, so players don't assume the GIF relates to that day's movies.
export const DEFAULT_GIF_URLS = [
  "xT9DPC0o6lUwV4QCAM", // Kate Winslet, Oscars standing ovation
  "wkBysf5P5eCOc",      // Leonardo DiCaprio, Oscar win
  "l0HU9256bimWZbHUc",  // Reese Witherspoon cheering, SAG Awards
  "l2JJr53pq0vpkpmU0",  // Brie Larson cheering, Oscars
  "4wycNsucv3ofC",      // Bill Murray clapping, Oscars
  "CjGik0HO9casyXHFh1", // Lady Gaga applauding
  "1j8NQqPW0socf8YqjN", // Jim Carrey clapping, Golden Globes
  "qIXVd1RoKGqlO",      // Awards-show standing ovation
  "WOSu3TcTmEhvdgiFBl", // Adam Driver applauding
  "3o7abmoAtl5RLk6BmE", // Kevin Hart applauding, Oscars
  "YnTcwu1DP9cXVD7zz8", // Charlize Theron applauding
  "3ornjHL4fLS94x39Wo", // Oscars audience applause
  "asXQmrvtPHwNG",      // Oscars bear applauding
  "8Pvfy6bWv6UH5sYbAN", // Brian May applauding, Oscars
  "gijDHXas4FTDEHrbGn", // Billy Crudup applauding
  "KJCsv8KcpwHjG",      // Packed theater standing ovation
  "1d5Zna1NGi95Dc1ulp", // Awards audience applause
].map((id) => `https://media.giphy.com/media/${id}/giphy.gif`);

export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (["localhost", "127.0.0.1"].includes(window.location.hostname)
    ? "http://localhost:5001"
    : "https://reely-backend.onrender.com");
